import { createAction } from '@reduxjs/toolkit';

// Fix param types

export const viewAndEditBudget = createAction<any>('VIEW_AND_EDIT_BUDGET');

export const viewBudgetByCostRate = createAction<any>(
  'VIEW_BUDGET_BY_COST_RATE'
);
